import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import CalendarSvg from '../../../../assets/icons/primary/Calendar.svg';
import InfoSvg from '../../../../assets/icons/primary/Info Circle.svg';
import {NoResultsView} from '../../../../components/NoResultsView';
import {Layout} from '../Layout';

type Props = {
  isSessionsLimitReached?: boolean;
};

export const TimeslotsEmptyState: FC<Props> = ({isSessionsLimitReached}) => {
  const {t} = useI18n();

  return (
    <Layout.EmptyStateContainer>
      <NoResultsView
        icon={isSessionsLimitReached ? InfoSvg : CalendarSvg}
        iconColor="icon.gray"
        iconSize={32}
        text={
          isSessionsLimitReached
            ? t('shared:book_conference.maximum_number_of_sessions_reached')
            : t('shared:book_conference.no_available_slots')
        }
      />
    </Layout.EmptyStateContainer>
  );
};
